export class ImageDataModel{
    uuid: string;
    mimeType: string;
    name: string;
    version: string;
    tipoImagen: string;
    tipoPatron: string;
    detalleImagen: string;
}
